import { compose } from "@reduxjs/toolkit";

import { ApiError, isApiError } from "../api/common";
import { toastError } from "../common/components/core";

export type GenericError = ApiError | Error;
export type ErrorHandler = (error: GenericError) => void;
export type ErrorHandlerCreator = (handler: ErrorHandler) => ErrorHandler;

const fallbackErrorHandler: ErrorHandler = (error) => {
    if (isApiError(error) && error.errors[0]) {
        switch (error.errors[0].key) {
            case "Claim.Error.ConcurrentException":
                toastError(error.errors[0].enMessage, false);
                break;
            case "exception.internal":
                break;
            case "Error.Unknown":
                toastError("Unknown error occurred");
                break;
            case "Evm.Revert":
                toastError(error.errors[0].enMessage);
                break;
            case "argument.unreadable":
                return;
            default:
                toastError(error.errors[0].key);
        }
    } else {
        console.error(error);
        toastError("Unknown error occurred");
    }
};

export const onStaleStateError =
    (handler: () => void): ErrorHandlerCreator =>
    (next) =>
    (error) => {
        if (
            isApiError(error) &&
            (error.errors[0]?.key === "Corda.Query.NotFound" ||
                error.errors[0]?.key === "Corda.Verification.ContractReject")
        ) {
            handler();
        } else {
            next(error);
        }
    };

export const onBankStateError =
    (handler: () => void): ErrorHandlerCreator =>
    (next) =>
    (error) => {
        if (isApiError(error) && error.errors[0]?.key === "Bank.Error.InvalidStatus") {
            handler();
        } else {
            next(error);
        }
    };

export const composeErrorHandlers = (
    ...handlers: ErrorHandlerCreator[]
): ErrorHandler => {
    return compose<ErrorHandler>(...handlers)(fallbackErrorHandler);
};

export const ltaErrorCodeMapping = (rejectCode: string, rejectReason: string): string => {
    return (rejectCode === "12000515" && rejectReason === "TX_QUOTA_LIMIT_REACHED") ? "LTA PYMT LIMIT BREACHED" : rejectReason;
}
